import { withCloseAfterExited } from "../modal";
import {
  default as View,
  UnassignAdminModalProps
} from "./unassign-admin-modal-view";

const UnassignAdminModal = withCloseAfterExited<UnassignAdminModalProps>(View);
export default UnassignAdminModal;
